import type { AdminServiceUsageRate, NormalizeAdminServiceUsageRateFromApiParams } from '../types';
import throwUnsupportedAdminServiceBilling from './throwUnsupportedAdminServiceBilling';

const normalizeAdminServiceUsageRateFromApi = ({
    rate,
}: NormalizeAdminServiceUsageRateFromApiParams): AdminServiceUsageRate => {
    const rateRecord = rate as { model?: unknown } & Partial<AdminServiceUsageRate>;

    if (rateRecord.model === 'per_unit') {
        const perUnitRate = rate as Extract<AdminServiceUsageRate, { model: 'per_unit' }>;
        return {
            model: 'per_unit',
            unitAmountCents: perUnitRate.unitAmountCents,
        };
    }

    if (rateRecord.model === 'included_overage') {
        const includedOverageRate = rate as Extract<
            AdminServiceUsageRate,
            { model: 'included_overage' }
        >;
        return {
            model: 'included_overage',
            baseAmountCents: includedOverageRate.baseAmountCents,
            includedUnits: includedOverageRate.includedUnits,
            overageUnitAmountCents: includedOverageRate.overageUnitAmountCents,
        };
    }

    if (rateRecord.model === 'tiered') {
        const tieredRate = rate as Extract<AdminServiceUsageRate, { model: 'tiered' }>;
        if (tieredRate.calculation !== 'graduated' && tieredRate.calculation !== 'volume') {
            return throwUnsupportedAdminServiceBilling({
                message: `Unsupported service billing from API: tier calculation ${String(
                    tieredRate.calculation
                )}`,
            });
        }

        return {
            model: 'tiered',
            calculation: tieredRate.calculation,
            tiers: tieredRate.tiers.map(tier => ({
                id: tier.id,
                upToUnits: tier.upToUnits,
                flatAmountCents: tier.flatAmountCents,
                unitAmountCents: tier.unitAmountCents,
            })),
        };
    }

    return throwUnsupportedAdminServiceBilling({
        message: `Unsupported service billing from API: rate model ${String(rateRecord.model)}`,
    });
};

export default normalizeAdminServiceUsageRateFromApi;
